import { render, staticRenderFns } from "./modal-timing-on-down.vue?vue&type=template&id=94c5cd66&scoped=true"
import script from "./modal-timing-on-down.vue?vue&type=script&lang=js"
export * from "./modal-timing-on-down.vue?vue&type=script&lang=js"
import style0 from "./modal-timing-on-down.vue?vue&type=style&index=0&id=94c5cd66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c5cd66",
  null
  
)

export default component.exports